import {
    GET_STATES,
    SELECT_STATE,
	IS_LOADING,
    GET_TOASTR, CHECK_EMAIL,
    GET_REGIONS,
    GET_DISTRICTS,
    GET_CATEGORIES,
    GET_COLORS,
    GET_SIZES,
    GET_PRODUCTTYPES,
    REMOVE_EMAIL_MESSAGE,
    CHECK_ADDRESS,
    GET_PAYMENT_TYPES,
    RESET_PASSWORD_SUBMIT,
    SET_ACCOUNTLOADER,
    SET_MEMBERSHIPLOADER,
    SET_PURCHASEHISTORYLOADER,
    GET_REGION_AND_DISTRICTSUPERVISOR,
    GET_BATCH_STATUSES,
    GET_BATCH_TYPES
} from '../Actions/CommonActions';
    
const initialState = {
    states: [],
    selectedState: null,
    loading: false,
    error: null,
    visible: false,
    message: null,
    color: null,
    emailMessage: null,
    regions: [],
    districts: [],
    eventCategories:[],
    allColors:[],
    allSizes: [],
    batchTypes:[],
    productTypes:[],
    emailExists:true,
    addressExists: true,
    emailSent: false,
    error: false,
    accountLoader: true,
    membershipLoader: true,
    purchaseHistoryLoader: true,
    batchStatuses: []
 };
    
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_STATES:
            return {
                ...state,
                states: action.states
            };
        case SELECT_STATE:
            return {
                ...state,
                selectedState: action.selectedState
            };
        case GET_REGION_AND_DISTRICTSUPERVISOR:
            return {
                ...state,
                supervisors: action.supervisors
            }
        case IS_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case SET_ACCOUNTLOADER:
            return {
                ...state,
                accountLoader: action.loader
            };

        case SET_MEMBERSHIPLOADER:
            return {
                ...state,
                membershipLoader: action.loader
            };

        case SET_PURCHASEHISTORYLOADER:
            return {
                ...state,
                purchaseHistoryLoader: action.loader
            };
        case CHECK_EMAIL:
             return {
            ...state,
            emailMessage: action.emailMessage,
            emailExists: action.emailExists
        };
        case REMOVE_EMAIL_MESSAGE:
             return {
            ...state,
            emailMessage: action.emailMessage,
            emailExists: action.emailExists
        };
		case GET_TOASTR:
			return {
				...state,
				visible: action.visible,
				message: action.message,
				color:action.color
            };
        case GET_REGIONS:
            return {
                ...state,
                regions: action.regions
            };
        case GET_DISTRICTS:
            return {
                ...state,
                districts: action.districts
            };
        case GET_CATEGORIES:
            return {
                ...state,
                eventCategories: action.payload
            };
        case GET_COLORS:
            return {
                ...state,
                allColors: action.payload
            };
        case GET_SIZES:
            return {
                ...state,
                allSizes: action.payload
            };
        case GET_PRODUCTTYPES:
            return {
                ...state,
                productTypes: action.payload
            };
        case CHECK_ADDRESS:
            return {
                ...state,
                addressExists: action.payload
            };
        case GET_PAYMENT_TYPES:
            return {
                ...state,
                paymentTypes: action.payload
            };
        case RESET_PASSWORD_SUBMIT:
            return {
                ...state,
                emailSent: action.payload.emailSent,
                error: action.payload.error
            }
        case GET_BATCH_STATUSES:
            return {
                ...state,
                batchStatuses: action.payload
            }
        case GET_BATCH_TYPES:
            return {
                ...state,
                batchTypes: action.payload
            }
        default:
            return state;
    }
}
